module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/192-philippines-dd9353e4634085ee496bbc4f2388142e.svg";